import { SecureStorage } from "../../storage/SecureStorage";
import { useEffect, useState } from "react";

type StoredUser = {
  id: number;
  fullName: string;
  email: string;
  phone: string;
  sex: string;
  dateOfBirth: string;
  postcode?: number | null;
  postAddress?: string;
  dni?: string | null;
  profilePictureName?: string | null;
};

export default function ProfilePage() {
  const [user, setUser] = useState<StoredUser | null>(null);

  useEffect(() => {
    (async () => {
      const currentUser = await SecureStorage.getUser();
      setUser(currentUser);
    })();
  }, []);

  if (!user) return <p style={{ padding: 16 }}>Cargando…</p>;

  const fechaNacimiento = sanitizeFechaNacimiento(user.dateOfBirth);

  return (
    <div style={{ background: "#f9f9f9", minHeight: "100vh", paddingBottom: "96px" }}>
      <h2 className="config-title">Mi Perfil</h2>
      {/* Contenido */}
      <div style={{ padding: "16px" }}>
        <div
          style={{
            background: "white",
            borderRadius: 12,
            padding: "16px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          <h3 style={{ fontSize: 16, marginBottom: 12, color: "#374151" }}>
            Información Personal
          </h3>


          <ProfileField label="Nombre completo" value={user.fullName} />
          <ProfileField label="Correo electrónico" value={user.email} />
          <ProfileField label="Teléfono" value={user.phone} />
          <ProfileField label="Sexo" value={user.sex} />
          <ProfileField label="Fecha de nacimiento" value={fechaNacimiento} />
          <ProfileField label="DNI" value={user.dni || "—"} />
          <ProfileField label="Dirección postal" value={user.postAddress || "—"} />
          <ProfileField label="Código postal" value={user.postcode?.toString() || "—"} />
        </div>
      </div>
    </div>
  );
}

function ProfileField({ label, value }: { label: string; value: string }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 15, fontWeight: 500 }}>{value}</div>
    </div>
  );
}

function sanitizeFechaNacimiento(input: string): string {
  const date = input.slice(0, 10);
  return date;
}
